import { useWindowWidth } from '@prishapolicy/shared/ui';
import { Dispatch, SetStateAction } from 'react';
import { ProductCategoryPageProps } from '../../product-category';
import Image from 'next/image';
// import dynamic from 'next/dynamic';
export type PurchaseFlowIconRendererProps = {
  purchaseFlowData: ProductCategoryPageProps;
  activeForm: number;
  setActiveForm: Dispatch<SetStateAction<number>>;
};

const SSRPurchaseFlowIconRenderer = ({ ...props }: PurchaseFlowIconRendererProps) => {
  const purchaseFlowForms = props.purchaseFlowData.purchaseFlowForms;
  const multipleForms = purchaseFlowForms && purchaseFlowForms.length > 1;
  const activeForm = props.activeForm;
  const setActiveForm = props.setActiveForm;
  const { isLg } = useWindowWidth();
  return (
    <div className="bg-yellow mb-3 mt-10 flex w-full cursor-pointer gap-4 xl:w-3/5">
      {multipleForms &&
        purchaseFlowForms.map((purchaseflowProps, idx) => {
          return (
            <div onClick={() => setActiveForm(idx)} key={idx} className="grid flex-1 place-items-center">
              <div
                className={`grid place-items-center rounded-full bg-white p-2 ${
                  activeForm === idx ? 'border-primary border-2' : 'border-2 border-white'
                }`}
              >
                <Image
                  src={`/products/${props.purchaseFlowData.productCategorySlug}/${purchaseflowProps.productTypeSlug}/pf-icon.png`}
                  alt={purchaseflowProps.productTypeSlug || 'product icon'}
                  height={isLg ? 48 : 30}
                  width={isLg ? 48 : 30}
                />
              </div>
              <div className={`text-center ${activeForm === idx && 'text-primary'} font-medium`}>
                {purchaseflowProps.shortName || purchaseflowProps.productTypeSlug}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export const PurchaseFlowIconRenderer = SSRPurchaseFlowIconRenderer;
